export default __webpack_public_path__ + "static/media/ico-user-default.cd9d5b8c.svg";